import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  ISSUE_CREATE,
  ISSUE_TRAVEL_DETAIL,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Support",
    meta: { requiresAuth: true },
    redirect: { name: "CreateIssue" },
    component: () => import("@/modules/Support/Support"),
    children: [
      {
        path: "issue/create",
        name: "CreateIssue",
        component: () => import("@/modules/Support/Pages/Issue/Index.vue"),
        meta: {
          code: MODULE.SUPPORT.CODE,
        },
      },
      {
        path: "issue/travel/:rentalId",
        name: "SupportTravel",
        component: () =>
          import("@/modules/Support/Pages/Issue/SupportTravel.vue"),
        meta: {
          breadcrumb: [
            { name: "common.supportHome", link: ISSUE_CREATE },
            { name: "common.supportTravelDetail", link: ISSUE_TRAVEL_DETAIL },
          ],
          code: MODULE.SUPPORT.CODE,
        },
      },
    ],
  },
];
